/**
 * Temporary workaround:
 * Since API takes for ASC sorting param "+" param and angular has issues resolving this (https://github.com/angular/angular/issues/18261)
 * We need this temporary workaround until upper mentioned issues has been fiexed or API has changed.
 *
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpParameterCodec, HttpParams, HttpResponse} from '@angular/common/http';


import {Observable} from 'rxjs/Observable';
import {BASE_PATH, CARDINFO, Configuration, POOLINFO, SMDPPROFILE} from '../../../../gen/swagger-api';
import {CARDGROUPINFO} from '../../../../gen/swagger-api/model/cARDGROUPINFO';
import {CustomHttpUrlEncodingCodec} from '../../../../gen/swagger-api/encoder';


class CustomEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(value: string): string {
    var value = encodeURIComponent(value);
    value = value.replace('%2B', '+');
    return value;
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}


@Injectable()
export class DefaultServiceGetSubscriptionPools {

  protected basePath = 'https://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (let consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }


  /**
   *
   * Card group list getting operation. This is the operation to get a list of card groups managed by the authenticated account
   * @param offset An offset for a list (required for pagination)
   * @param limit A maximum number of entries returned by the request
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardGroupsGet(offset?: number, limit?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<CARDGROUPINFO>>;
  public cardGroupsGet(offset?: number, limit?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CARDGROUPINFO>>>;
  public cardGroupsGet(offset?: number, limit?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CARDGROUPINFO>>>;
  public cardGroupsGet(offset?: number, limit?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (offset !== undefined) {
      queryParameters = queryParameters.set('offset', <any>offset);
    }
    if (limit !== undefined) {
      queryParameters = queryParameters.set('limit', <any>limit);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<Array<CARDGROUPINFO>>(`${this.basePath}/card_groups`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }



  /**
   *
   * Get a list of profiles from a specified pool
   * @param poolId Id of requested pool
   * @param status Filter for status of profiles
   * @param searchString String to search for cards with specific iccid or msisdn or imsi in the pool. Sort order from old records to new ones
   * @param sortString The string that defines the sorting. It has the following form XYYYYYY, XYYYYYYY. X - sort order. if x - &#39;-&#39; then descending, if x - &#39;+&#39;, then ascending. Y - name of the field by which the records are sorted. Available values for Y  - pool_id,  - viccid,  - iccid,  - imsi  - msisdn  - status
   * @param offset An offset for a list (required for pagination)
   * @param limit A maximum number of entries returned by the request
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public poolsPoolIdProfilesGet(poolId: number, offset?: number, limit?: number, searchString?: string, sortString?: string, status?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SMDPPROFILE>>;
  public poolsPoolIdProfilesGet(poolId: number, offset?: number, limit?: number, searchString?: string, sortString?: string, status?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SMDPPROFILE>>>;
  public poolsPoolIdProfilesGet(poolId: number, offset?: number, limit?: number, searchString?: string, sortString?: string, status?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SMDPPROFILE>>>;
  public poolsPoolIdProfilesGet(poolId: number, offset?: number, limit?: number, searchString?: string, sortString?: string, status?: string,observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (poolId === null || poolId === undefined) {
      throw new Error('Required parameter poolId was null or undefined when calling poolsPoolIdProfilesGet.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (status !== undefined) {
      queryParameters = queryParameters.set('status', <any>status);
    }
    if (searchString !== undefined) {
      queryParameters = queryParameters.set('search_string', <any>searchString);
    }
    if (sortString !== undefined) {
      queryParameters = queryParameters.set('sort_string', <any>sortString);
    }
    if (offset !== undefined) {
      queryParameters = queryParameters.set('offset', <any>offset);
    }
    if (limit !== undefined) {
      queryParameters = queryParameters.set('limit', <any>limit);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<Array<SMDPPROFILE>>(`${this.basePath}/pools/${encodeURIComponent(String(poolId))}/profiles`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * List of pools getting operation. This is the operation to get a list of pools managed by the authenticated account
   * @param offset An offset for a list (required for pagination)
   * @param limit A maximum number of entries returned by the request
   * @param poolId Filter records by pool ids
   * @param poolName Filter records by pool names
   * @param country Filter records by country
   * @param mnoId Filter records by MNO ID
   * @param sortString The string that defines the sorting. It has the following form XYYYYYY, XYYYYYYY. X - sort order. if x - &#39;-&#39; then descending, if x - &#39;+&#39;, then ascending. Y - name of the field by which the records are sorted. Available values for Y  - pool_id,  - pool_name,  - country,  - mno_id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public poolsGet(offset?: number, limit?: number, poolId?: Array<number>, poolName?: Array<string>, country?: Array<string>, mnoId?: Array<string>, sortString?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<POOLINFO>>;
  public poolsGet(offset?: number, limit?: number, poolId?: Array<number>, poolName?: Array<string>, country?: Array<string>, mnoId?: Array<string>, sortString?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<POOLINFO>>>;
  public poolsGet(offset?: number, limit?: number, poolId?: Array<number>, poolName?: Array<string>, country?: Array<string>, mnoId?: Array<string>, sortString?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<POOLINFO>>>;
  public poolsGet(offset?: number, limit?: number, poolId?: Array<number>, poolName?: Array<string>, country?: Array<string>, mnoId?: Array<string>, sortString?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (offset !== undefined) {
      queryParameters = queryParameters.set('offset', <any>offset);
    }
    if (limit !== undefined) {
      queryParameters = queryParameters.set('limit', <any>limit);
    }
    if (poolId) {
      poolId.forEach((element) => {
        queryParameters = queryParameters.append('pool_id', <any>element);
      })
    }
    if (poolName) {
      poolName.forEach((element) => {
        queryParameters = queryParameters.append('pool_name', <any>element);
      })
    }
    if (country) {
      country.forEach((element) => {
        queryParameters = queryParameters.append('country', <any>element);
      })
    }
    if (mnoId) {
      mnoId.forEach((element) => {
        queryParameters = queryParameters.append('mno_id', <any>element);
      })
    }
    if (sortString !== undefined) {
      queryParameters = queryParameters.set('sort_string', <any>sortString);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<Array<POOLINFO>>(`${this.basePath}/pools`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/workaround/default-service-get-subscription-pools.service.ts